import jsonSelector from './json'

const parametersSelector = jsonSelector('parameters')

export default parametersSelector



// WEBPACK FOOTER //
// ./src/selectors/parameters.js